module.exports = __webpack_public_path__ + "img/3.935def7d.jpg";